import { Type } from "@sinclair/typebox";
import { FileAsset, TranslatedString } from "./common";
export var BusinessHoursDisplayOptions;
(function (BusinessHoursDisplayOptions) {
    BusinessHoursDisplayOptions["OnlyShowDuringBusinessHours"] = "only_show_during_business_hours";
    BusinessHoursDisplayOptions["OnlyShowOutsideBusinessHours"] = "only_show_outside_business_hours";
    BusinessHoursDisplayOptions["AlwaysShow"] = "always_show";
})(BusinessHoursDisplayOptions || (BusinessHoursDisplayOptions = {}));
export const BusinessHoursSettings = Type.Object({
    setId: Type.String({ minLength: 1 }),
    displayOptions: Type.Optional(Type.Enum(BusinessHoursDisplayOptions, {
        default: BusinessHoursDisplayOptions.OnlyShowDuringBusinessHours,
    })),
    showIndicationInWidgetHeader: Type.Optional(Type.Boolean()),
    indicationMessage: Type.Optional(TranslatedString),
});
export const FlowLinkCard = Type.Object({
    type: Type.Literal("FlowLinkCard"),
    title: TranslatedString,
    subtitle: TranslatedString,
    flowId: Type.String({ minLength: 1 }),
    disabled: Type.Boolean(),
    id: Type.String(),
    usergroupIds: Type.Array(Type.String()),
    excludedUsergroupIds: Type.Array(Type.String()),
    businessHoursEnabled: Type.Optional(Type.Boolean()),
    businessHoursSettings: Type.Optional(BusinessHoursSettings),
}, {
    title: "FlowLinkCard",
});
export const LinkListCard = Type.Object({
    type: Type.Literal("LinkListCard"),
    title: TranslatedString,
    links: Type.Array(Type.Object({
        title: TranslatedString,
        favicon: Type.Optional(Type.String()),
        url: Type.String({
            pattern: "^((http|https)://)(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$",
        }),
    })),
    usergroupIds: Type.Array(Type.String()),
    excludedUsergroupIds: Type.Array(Type.String()),
    disabled: Type.Boolean(),
    id: Type.String(),
}, {
    title: "LinkListCard",
});
export const MessageHistoryCard = Type.Object({
    type: Type.Literal("MessageHistoryCard"),
    maxAgeSeconds: Type.Optional(Type.Number()),
    usergroupIds: Type.Array(Type.String()),
    excludedUsergroupIds: Type.Array(Type.String()),
    disabled: Type.Boolean(),
    id: Type.String(),
}, {
    title: "MessageHistoryCard",
});
export const NewsListCard = Type.Object({
    type: Type.Literal("NewsListCard"),
    mode: Type.Union([Type.Literal("card"), Type.Literal("list")]),
    title: Type.Optional(TranslatedString),
    selection: Type.Union([Type.Literal("latest"), Type.Literal("manual")]),
    numPosts: Type.Number(),
    postIds: Type.Optional(Type.Array(Type.String())),
    categoryIds: Type.Optional(Type.Array(Type.String())),
    usergroupIds: Type.Array(Type.String()),
    excludedUsergroupIds: Type.Array(Type.String()),
    disabled: Type.Boolean(),
    id: Type.String(),
}, {
    title: "NewsListCard",
});
export const SubmitTicketCard = Type.Object({
    type: Type.Literal("SubmitTicketCard"),
    ticketFields: Type.Object({
        email: Type.Boolean(),
        name: Type.Boolean(),
        phone_number: Type.Boolean(),
        subject: Type.Boolean(),
        message: Type.Boolean(),
    }),
    departmentId: Type.String({ minLength: 1 }),
    usergroupIds: Type.Array(Type.String()),
    excludedUsergroupIds: Type.Array(Type.String()),
    disabled: Type.Boolean(),
    id: Type.String(),
}, {
    title: "SubmitTicketCard",
});
export const HelpContentType = Type.Union([
    Type.Literal("article"),
    Type.Literal("guide_page"),
    Type.Literal("download"),
    Type.Literal("news"),
    Type.Literal("community_topic"),
]);
export const HelpContentCard = Type.Object({
    type: Type.Literal("HelpContentCard"),
    isSearchEnabled: Type.Optional(Type.Boolean()),
    content: Type.Optional(Type.Array(Type.Object({
        type: HelpContentType,
        id: Type.String(),
    }))),
    categories: Type.Optional(Type.Array(Type.Object({
        type: Type.Literal("knowledgebase_category"),
        id: Type.String(),
    }))),
    usergroupIds: Type.Array(Type.String()),
    excludedUsergroupIds: Type.Array(Type.String()),
    disabled: Type.Boolean(),
    id: Type.String(),
}, {
    title: "HelpContentCard",
});
export const CustomCard = Type.Object({
    type: Type.Literal("CustomCard"),
    image: Type.Object({
        enabled: Type.Boolean({ default: false }),
        file: Type.Optional(FileAsset),
    }),
    icon: Type.Object({
        enabled: Type.Boolean({ default: false }),
        file: Type.Optional(Type.Union([
            Type.Object({
                type: Type.Literal("emoji"),
                emoji: Type.String(),
            }),
            Type.Object({
                type: Type.Literal("image"),
                asset: FileAsset,
            }),
        ])),
    }),
    title: TranslatedString,
    text: TranslatedString,
    usergroupIds: Type.Array(Type.String()),
    excludedUsergroupIds: Type.Array(Type.String()),
    disabled: Type.Boolean(),
    id: Type.String(),
}, {
    title: "CustomCardCard",
});
